(function() {
  'use strict';

  var SCROLL_THRESHOLD = 600;

  function createButton() {
    var btn = document.createElement('button');
    btn.className = 'lnc-back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M12 10L8 6L4 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';

    var style = document.createElement('style');
    style.textContent =
      '.lnc-back-to-top {' +
        'position: fixed;' +
        'bottom: 96px;' + /* clears the MooseDesk Help launcher */
        'right: 24px;' +
        'width: 40px;' +
        'height: 40px;' +
        'border-radius: 50%;' +
        'background: var(--lnc-elevated, #141414);' +
        'border: 1px solid var(--lnc-border, #2a2a2a);' +
        'color: var(--lnc-white, #fff);' +
        'cursor: pointer;' +
        'display: flex;' +
        'align-items: center;' +
        'justify-content: center;' +
        'opacity: 0;' +
        'visibility: hidden;' +
        'transition: opacity 0.3s ease, visibility 0.3s ease, background 0.2s ease;' +
        'z-index: 100;' +
        'padding: 0;' +
      '}' +
      '.lnc-back-to-top--visible {' +
        'opacity: 1;' +
        'visibility: visible;' +
      '}' +
      '.lnc-back-to-top:hover {' +
        'background: var(--lnc-hover, #1c1c1c);' +
      '}' +
      '@media (max-width: 749px) {' + /* clears the 56px mobile bottom nav */
        '.lnc-back-to-top { bottom: calc(72px + env(safe-area-inset-bottom, 0px)); }' +
      '}' +
      'body.lnc-hide-chat .lnc-back-to-top { display: none; }' + /* PDP sticky bar, sheets */
      '@media (prefers-reduced-motion: reduce) {' +
        '.lnc-back-to-top { transition: none; }' +
      '}';

    document.head.appendChild(style);
    document.body.appendChild(btn);

    return btn;
  }

  function init() {
    var btn = createButton();
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          if (window.scrollY > SCROLL_THRESHOLD) {
            btn.classList.add('lnc-back-to-top--visible');
          } else {
            btn.classList.remove('lnc-back-to-top--visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
